module.exports = __webpack_public_path__ + "img/vikings-1.1192bc94.webp";